import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Home from './views/Home.vue'
import ProductRegister from './views/ProductRegister.vue'
import Safety from './views/Safety.vue'
import Product from './views/Product.vue'
import Analysis from './views/Analysis.vue'
import Enterprisemb from './views/Enterprisemb.vue'
import EnterprisembDetails from './views/EnterprisembDetails.vue'
import Genre from './views/Genre.vue'
import GoodsCode from './views/GoodsCode.vue'
import GoodsCodeEdit from './views/GoodsCodeEdit.vue'
import GoodsCodeAdd from './views/GoodsCodeAdd.vue'
import PersonalCard from './views/personalCard.vue'
import PersonalEdit from './views/personalEdit.vue'
import CompanyCard from './views/companyCard.vue'
import CompanyEdit from './views/companyEdit.vue'
import MtStyle from './views/mtStyle.vue'
const genreSlip = () =>
	import('@/views/GenreSlip.vue')
// const LightApp = () =>
// 	import('@/views/LightApp.vue')

import Genrelist from './views/Genrelist.vue'
import GenrelistDetails from '@/views/GenrelistDetails.vue'
//EnterprisembDetails.vue
//Genre.vue

import Succeed from './views/succeed.vue'
import applyText from './views/applyText.vue'
import indent from './views/indent.vue'

import continueExplain from './views/continueExplain.vue'

Vue.use(Router)

export default new Router({
	// mode: 'history',
	base: '/unitIndex/',
	//	base: process.env.BASE_URL,
	//   activeClass:'is-active',
	scrollBehavior(to, from, savedPosition) {
		if(to.name == "name") {
			return {
				x: 0,
				y: 0
			}
		}

	},
	routes: [{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				presentName: '首页',
				tier: 1,
				jurisdictionPerfection: false

			}
		},
		{
			path: '/about', //暂无
			name: 'about',
	
			component: () =>
				import( /* webpackChunkName: "about" */ './views/About.vue'),
			meta: {
				presentName: '关于我们',
				tier: 2,
				jurisdictionPerfection: false

			}
		},
		{
			path: '/productregister', //注册码标
			name: 'productregister',
			component: ProductRegister,
			meta: {
				presentName: '注册码标',
				tier: 1,
				jurisdictionPerfection: false

			}
		},
		{
			path: '/continueexplain/', //特殊注册
			name: 'continueexplain',
			props: (route) => ({
				name: route.query.name,
				price: route.query.price
			}),
			component: continueExplain,
			meta: {
				jurisdictionPerfection: false

			}
		},
		{
			path: '/audit', //特殊注册审核页面
			name: 'audit',
			component: () =>
				import( /* webpackChunkName: "about" */ '@/components/audit.vue'),
		},
		{
			path: '/thetransfer', //过户
			name: 'TheTransfer',
			component: () =>
				import('./views/TheTransfer.vue'),
			props: (route) => ({
				id: parseInt(route.query.id)
			}),
			meta: {
				jurisdictionPerfection: false

			},

		}, {
			path: '/renew', //注册付款
			name: 'Renew',
			component: () =>
				import('./views/Renew.vue'),
			props: (route) => ({
				name: route.query.name,
				type: parseInt(route.query.type),
				id: parseInt(route.query.id)
			}),
			meta: {
				jurisdictionPerfection: false

			},

		},

		{
			path: '/Safety', //修改密码
			name: 'Safety',
			component: Safety,
			meta: {
				jurisdictionPerfection: true

			},
		},
		{
			path: '/perfect', //企业资料填写
			name: 'perfect',
			component: () =>
				import('./views/perfect.vue'),
			meta: {
				subordinate: '/',
				describe: '企业资料填写',
				jurisdictionPerfection: false

			},
		},
		{
			path: '/personage', //个人信息填写
			name: 'personage',
			component: () =>
				import('./components/information/Personage.vue'),
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/product', //填写码标信息
			name: 'product',
			component: Product,
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/analysis', //填写码标信息
			name: 'analysis',
			component: Analysis,
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/enterprisemb', //企业码标管理
			name: 'enterprisemb',
			component: Enterprisemb,
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/enterprisembdetails', //企业码标二级详情
			name: 'enterprisembdetails',
			component: EnterprisembDetails,
			props: (route) => ({
				id: route.query.id,
			}),
			meta: {
				subordinate: '/enterprisemb',
				jurisdictionPerfection: false

			},
		},
		{
			path: '/succeed', //支付成功
			name: 'succeed',
			component: Succeed,
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/indent', //订单/续费
			name: 'indent',
			component: indent,
			props: (route) => ({
				id: route.query.indentId,
			}),
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/applytext', //支付跳转页面
			name: 'applytext',
			component: applyText,
			props: (route) => ({
				html: route.query.html,
			}),
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/genre', //品类注册
			component: Genre,
			children: [{
					path: '/genre',
					name: "genreselect",
					component: () =>
						import('@/components/GenreSelect.vue'),
					beforeEnter(to, from, next) {
						store.commit('increment', 1)
						if(to.query.hasOwnProperty('user')) {
							next();
//							if(to.query.user != unescape(instrumentVue.$getCookie('userName'))) {
//								instrumentVue.$setCookie('userName', encodeURI(to.query.user))
//							}
							//		return;
						} else {
							let Newto = { ...to
							};
							//console.log( instrumentVue.$getCookie('userName'))
							if(Newto.query.user == '') {
//								instrumentVue.$setCookie('userName', encodeURI('null'))
								delete Newto.user;
							} else {
								Newto.query.user = decodeURI(instrumentVue.$getCookie('userName'));
							}

							next(Newto);

						}
						//						next()
					},
				},
				{
					path: '/add',
					name: "add",
					props: true,
					component: () =>
						import('@/components/GenreAdd.vue'),
					props: (route) => ({
						typeId: route.params.typeid,
					}),
					beforeEnter(to, from, next) {
						store.commit('increment', 2)

						next()
					}
				},
				{
					path: '/genreanalysis',
					name: "genreanalysis",
					props: (route) => ({
						id: route.query.id,
						maid: route.query.maid,
						idcode: route.query.idcode,
					}),
					component: () =>
						import('@/components/Genreanalysis.vue'),
					beforeEnter(to, from, next) {
						store.commit('increment', 3)
						next()
					}
				},
			],
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/genreslip', //品类错误页面
			name: 'genreslip',
			component: genreSlip,
			props: (route) => ({
				statusCode: route.query.type,
			}),
			meta: {
				subordinate: '/genre',
				jurisdictionPerfection: false

			},
		},
		// {
		// 	path: '/lightapp', //轻应用错误页面
		// 	name: 'lightapp',
		// 	component: LightApp,
		// 	props: (route) => ({
		// 		statusCode: route.query.type,
		// 	}),
		// 	meta: {
		// 		subordinate: '3',
		// 		//				jurisdictionPerfection: true
		// 		jurisdictionPerfection: false

		// 	},
		// },
		{
			path: '/personalCard', //个人名片
			name: 'personalCard',
			component: PersonalCard,
			meta: {
				jurisdictionPerfection: false
		
			},
		},
		{
			path: '/personalEdit', //个人名片
			name: 'personalEdit',
			component: PersonalEdit,
			meta: {
				jurisdictionPerfection: false
		
			},
		},
		{
			path: '/GoodsCode', //个人名片
			name: 'GoodsCode',
			component: GoodsCode,
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/companyCard', //企业名片
			name: 'companyCard',
			component: CompanyCard,
			meta: {
				jurisdictionPerfection: false
		
			},
		},
		{
			path: '/companyEdit', //企业名片
			name: 'companyEdit',
			component: CompanyEdit,
			meta: {
				jurisdictionPerfection: false
		
			},
		},
		{
			path: '/mtStyle', //码图设置
			name: 'mtStyle',
			component: MtStyle,
			meta: {
				jurisdictionPerfection: false
		
			},
		},
		{
			path: '/GoodsCodeEdit', // 个人名片编辑详情
			name: 'GoodsCodeEdit',
			component: GoodsCodeEdit,
			meta: {
				jurisdictionPerfection: false   

			},
		},
		{
			path: '/GoodsCodeAdd', // 个人名片新增
			name: 'GoodsCodeAdd',
			component: GoodsCodeAdd,
			meta: {
				jurisdictionPerfection: false  

			},
		},
		{
			path: '/genrelist', //品类管理
			name: 'genrelist',
			component: Genrelist,
			meta: {
				jurisdictionPerfection: false

				//				jurisdictionPerfection: true

			},
		},
		{
			path: '/genrelistdetails', //品类管理列表二级
			name: 'genrelistdetails',
			component: GenrelistDetails,
			props: (route) => ({
				id: route.query.id,
				ma: route.query.ma
			}),
			//GenrelistDetails
			meta: {
				jurisdictionPerfection: false

			},
		},
		{
			path: '/destroy', //支付宝销毁
			name: 'destroy',
			//			destroy.vue
			component: () =>
				import('@/components/destroy.vue'),
			meta: {
				jurisdictionPerfection: false

			},

		},
		//		{
		//			path: '/d', 
		//			name: 'd',
		//			component: () =>
		//				import('@/components/dai/disparkAdministration.vue'),
		//			meta: [],
		//
		//		},
		//		{
		//		    path: '/disparkparticulars', 
		//			name: 'disparkparticulars',
		//			component: () =>
		//				import('@/components/dai/disparkParticulars.vue'),
		//				props: (route) => ({
		//					id: route.query.id,
		//					
		//				}),
		//			meta: [],
		//		},
		{
			path: '/dataSubmitted', //资料提交
			name: 'dataSubmitted',
			component: () =>
				import('@/views/DataSubmitted.vue'),
			props: (route) => ({
				maID: parseInt(route.query.id)
			}),
			meta: {
				jurisdictionPerfection: false

			},

		},
		{
			path: '/t', //测试
			name: 't',
			component: () =>
				import('@/components/Renew-test.vue'),
			meta: {
				jurisdictionPerfection: false

			},

		},

		{
			path: '*',
			//			component: Home
			redirect: "/"

		},
	]
})